import React from "react";

import Button from "@mui/material/Button";

import ManageTags from "@app/analytics/components/TagPopover/ManageTags";
import useManageTags, {
  UseManageTagsArgs,
} from "@app/analytics/components/TagPopover/useManageTags";
import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";
import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import { toast } from "@app/common/hooks/useToasts";

import { Column } from "@rui/Stack";

import type { ManageTagsProps } from "./types";

const ManageReportTagsDialog = ({
  allTags,
  appliedTags,
  canApplyToSeries,
  onSave,
}: ManageTagsProps) => {
  const setDialog = useMeetingReportUiStore((state) => state.setDialog);

  const closeDialog = () => setDialog(null);

  const handleSave: UseManageTagsArgs["onSave"] = (
    updatedTags,
    applyToSeries
  ) => {
    onSave.mutate(
      { updatedTags, applyToSeries },
      {
        onSuccess: closeDialog,
        onError: () =>
          toast.error(
            "Oops! Something went wrong and one or more of your tags could not be saved."
          ),
      }
    );
  };

  const { onRemoveAll, ...manageTagsProps } = useManageTags({
    allTags,
    appliedTags,
    canApplyToSeries,
    onSave: handleSave,
  });

  return (
    <MobileDialog
      id="tags"
      title={`Tags (${appliedTags.length})`}
      headerAction={
        <Button
          color="error"
          sx={{ fontSize: "0.75rem" }}
          onClick={onRemoveAll}
          disabled={manageTagsProps.appliedTags.length < 1}
        >
          Remove all
        </Button>
      }
    >
      <Column spacing={1}>
        <ManageTags
          {...manageTagsProps}
          canApplyToSeries={canApplyToSeries}
          loading={onSave.isPending}
          onClose={closeDialog}
        />
      </Column>
    </MobileDialog>
  );
};

export default ManageReportTagsDialog;
